<div class="wizard-container">
	<nav class="wizard-stepper" aria-label="Stappen">
		@for (stap of stappen; track stap.nummer) {
			@if (!$first) {
				<div class="step-connector" [class.step-connector--done]="currentStap() > stap.nummer"></div>
			}
			<div class="step" [class.step--clickable]="currentStap() > stap.nummer" (click)="navigeerNaarStap(stap.nummer)">
				<div
					class="step__circle"
					[class.step__circle--active]="currentStap() === stap.nummer"
					[class.step__circle--done]="currentStap() > stap.nummer"
				>
					@if (currentStap() > stap.nummer) {
						✓
					} @else {
						{{ stap.nummer }}
					}
				</div>
				<div
					class="step__label"
					[class.step__label--active]="currentStap() === stap.nummer"
					[class.step__label--done]="currentStap() > stap.nummer"
				>
					{{ stap.label }}
				</div>
			</div>
		}
	</nav>

	<div class="wizard-content">
		@switch (currentStap()) {
			@case (1) {
				<div class="uitleg">
					<h3>Vereisten</h3>
					<ul>
						<li>CumLaude feature moet aan staan in Somtoday.</li>
						<li>Gebruikers moeten CumLaude recht hebben.</li>
						<li>
							Alle omgevingen moeten een bulk dataverwerking hebben gehad, dit controleer je door op de instellingen pagina naar de
							betreffende school te gaan en dataverwerking panel te checken.
						</li>
					</ul>
					<h3>Deze pagina</h3>
					<p>Op deze pagina kies je de doelschool, de omgeving waar de gebruikers voortaan gebruik van moeten gaan maken.</p>
				</div>
				<app-instelling-migratie-selectie-list
					titel="Kies de doelschool"
					[instellingen]="instellingen() ?? []"
					[selectedIds]="doelSelectedIds()"
					[disabledIds]="doelDisabledIds()"
					(instellingToggled)="selectDoelInstelling($event)"
				></app-instelling-migratie-selectie-list>
			}
			@case (2) {
				<div class="uitleg">
					<h3>Deze pagina</h3>
					<p>Op deze pagina kies je de bronscholen, de omgevingen waar de gebruikers nu gebruik van maken.</p>
				</div>
				<app-instelling-migratie-selectie-list
					titel="Kies de bronscholen"
					[instellingen]="instellingen() ?? []"
					[selectedIds]="bronSelectedIds()"
					[disabledIds]="bronDisabledIds()"
					(instellingToggled)="toggleBronInstelling($event)"
				></app-instelling-migratie-selectie-list>
			}
			@case (3) {
				<div class="uitleg">
					<h3>Deze pagina</h3>
					<ul>
						<li>Op deze pagina kies je welke vestigingen in de bronscholen gekoppeld worden aan welke vestiging in de doelschool.</li>
						<li>Deze worden initieel gematched op de naam van de vestiging.</li>
						<li>Controleer de automatisch gematchte vestigingen en match de eventueel overgebleven vestigingen van de bronscholen.</li>
						<li>Een vestiging hoeft niet gematched te worden.</li>
					</ul>
				</div>
				@if (vestigingMatchGroup(); as matchGroup) {
					<div class="match-layout">
						<app-instelling-migratie-match-secties
							titel="Doelvestigingen"
							[unmatchedCount]="matchGroup.unmatched.length"
							unmatchedLabel="bronvestigingen zonder match"
							[autoCards]="vestigingCardsAutoMatch()"
							[manualCards]="vestigingCardsManualMatch()"
							placeholder="Selecteer bronvestigingen"
							emptyAutoMatchesText="Geen doelvestigingen met automatische match."
							emptyManualMatchesText="Geen doelvestigingen om handmatig te matchen."
							emptyText="Geen doelvestigingen gevonden voor de gekozen doelschool."
							(selectionChanged)="this.selectVestigingBron($event.matchIndex, $event.selection)"
						></app-instelling-migratie-match-secties>
					</div>
				}
			}
			@case (4) {
				@if (accountMatchGroup(); as matchGroup) {
					<div class="uitleg">
						<h3>Deze pagina</h3>
						<ul>
							<li>Op deze pagina kies je welke accounts in de bronscholen gekoppeld worden aan welke account in de doelschool.</li>
							<li>Eerst proberen we zoveel mogelijk accounts te matchen op emailadres.</li>
							<li>De overgebleven accounts worden vervolgens gematched op afkorting.</li>
							<li>Tot slot proberen we de dan nog overgebleven accounts te matchen op naam.</li>
							<li>Controleer de automatisch gematchte accounts en match de eventueel overgebleven accounts van de bronscholen.</li>
							<li>Een account hoeft niet gematched te worden.</li>
						</ul>
					</div>
					<div class="match-layout">
						<app-instelling-migratie-match-secties
							titel="Doelaccounts"
							[unmatchedCount]="matchGroup.unmatched.length"
							unmatchedLabel="bronaccounts zonder match"
							[autoCards]="accountCardsAutoMatched()"
							[manualCards]="accountCardsManualMatch()"
							placeholder="Selecteer bronaccounts"
							emptyAutoMatchesText="Geen doelaccounts met automatische match."
							emptyManualMatchesText="Geen doelaccounts om handmatig te matchen."
							emptyText="Geen doelaccounts gevonden voor de gekozen doelschool."
							(selectionChanged)="this.selectAccountBron($event.matchIndex, $event.selection)"
						></app-instelling-migratie-match-secties>
					</div>
				}
			}
			@case (5) {
				<div class="uitvoeren-stap">
					<h3>Uitvoeren</h3>
					<p>Alles is ingesteld. Klik op <strong>Uitvoeren</strong> om de migratie te starten.</p>
					@if (executionError(); as error) {
						<div class="error-message"><strong>Fout:</strong> {{ error }}</div>
					}
					@if (executionSuccess()) {
						<div class="success-message"><strong>Succes!</strong> De migratie is voltooid.</div>
						@if (executionStatistics(); as stats) {
							<table class="statistics-table">
								<thead>
									<tr>
										<th>Entiteit</th>
										<th>Aantal</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Vestigingen bijgewerkt</td>
										<td>{{ stats.vestigingenUpdated }}</td>
									</tr>
									<tr>
										<td>Accounts bijgewerkt</td>
										<td>{{ stats.accountsUpdated }}</td>
									</tr>
									<tr>
										<td>AI-chatconversaties gekopieerd</td>
										<td>{{ stats.aiChatConversatiesCopied }}</td>
									</tr>
									<tr>
										<td>Afwezigheidsredenen bijgewerkt</td>
										<td>{{ stats.afwezigheidsredenenUpdated }}</td>
									</tr>
									<tr>
										<td>Basisvaardigheden normen gekopieerd</td>
										<td>{{ stats.basisvaardighedenNormenCopied }}</td>
									</tr>
									<tr>
										<td>Data-export favorieten gekopieerd</td>
										<td>{{ stats.dataExportFavorietenCopied }}</td>
									</tr>
									<tr>
										<td>Favoriet mappen gekopieerd</td>
										<td>{{ stats.favorietMappenCopied }}</td>
									</tr>
									<tr>
										<td>Favorieten gekopieerd</td>
										<td>{{ stats.favorietenCopied }}</td>
									</tr>
									<tr>
										<td>Gedeelde pagina's (persoon) gekopieerd</td>
										<td>{{ stats.gedeeldePaginaPersonenCopied }}</td>
									</tr>
									<tr>
										<td>Gedeelde pagina URL's gekopieerd</td>
										<td>{{ stats.gedeeldePaginaUrlsCopied }}</td>
									</tr>
									<tr>
										<td>Leerling selecties gekopieerd</td>
										<td>{{ stats.leerlingSelectiesCopied }}</td>
									</tr>
									<tr>
										<td>Recent bezochte pagina's gekopieerd</td>
										<td>{{ stats.recenteBezochtePaginasCopied }}</td>
									</tr>
									<tr>
										<td>Vak uitsluitingen gekopieerd</td>
										<td>{{ stats.vakUitsluitingenCopied }}</td>
									</tr>
									<tr>
										<td>Vestiging clusters VSO gekopieerd</td>
										<td>{{ stats.vestigingClustersVsoCopied }}</td>
									</tr>
								</tbody>
							</table>
						}
					}
				</div>
			}
		}
	</div>

	<nav class="wizard-nav" aria-label="Navigatie">
		<app-button buttonType="secondary" (clickit)="vorigeStap()" [enabled]="currentStap() > 1">Vorige</app-button>
		@if (currentStap() < stappen.length) {
			<app-button (clickit)="volgendeStap()" [enabled]="canGoNext()">Volgende</app-button>
		} @else {
			<app-button (clickit)="executeMigration()" [enabled]="!isExecuting() && !executionSuccess()">Uitvoeren</app-button>
		}
	</nav>
</div>
